import { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import SelectInput from "./SelectInput";
import { GenericObjectArrayType, TOption } from "../../types/common";
import { TableFilterProps } from "../../types/table";
import FilterForm from "../pages/reports/FilterForm";
import { openModal } from "../../utils/modalUtils";
import { SettingsOutline } from "@raresail/react-ionicons";
import { disableFutureDates } from "../../utils/helpers";

const { RangePicker } = DatePicker;

export const TableFilter = (props: TableFilterProps) => {
  const {
    name,
    onChange,
    updateFilterValues,
    filters,
    type,
    selectOptions,
    showHeaders = false,
    header,
    rangeNames,
  } = props;
  const [options, setOptions] = useState<TOption[]>([]);

  useEffect(() => {
    if (selectOptions) {
      const options = selectOptions || [];
      setOptions(
        options.map((sub: GenericObjectArrayType) => ({
          value: sub.id,
          label: sub.name,
        })),
      );
    }
  }, [selectOptions]);

  function handleFilter() {
    openModal({
      title: "Select filter",
      type: "form",
      formId: "filter-form",
      body: (
        <FilterForm
          filterOptions={{
            startDateKey: `${name}_min_date`,
            endDateKey: `${name}_max_date`,
          }}
        />
      ),
      okText: "Apply",
    })
      .then(({ currValue, stringValue }: any) => {
        updateFilterValues({ ...currValue, stringValue });
      })
      .catch(() => {});
  }

  const TitleText = () => {
    return (
      <div className="capitalize font12 mb-1">Filter by {header || name} </div>
    );
  };

  if (type === "select")
    return (
      <div>
        {showHeaders && <TitleText />}
        <SelectInput
          options={options}
          name={name}
          value={
            isNaN(filters?.[name] as any)
              ? filters?.[name]
              : Number(filters?.[name])
          }
          onChange={(value) => onChange(name, value)}
          label={""}
          // placeholder={`Search ${header || name}`}
          error={{}}
        />
      </div>
    );

  if (type === "date") {
    const startKey = rangeNames?.startKey || `${name}_after`;
    const endKey = rangeNames?.endKey || `${name}_before`;

    return (
      <div>
        {showHeaders && <TitleText />}
        <RangePicker
          onChange={(value: any) => {
            updateFilterValues({
              [startKey]: value?.[0].format("YYYY-MM-DD") || null,
              [endKey]: value?.[1].format("YYYY-MM-DD") || null,
            });
          }}
          value={[
            filters?.[startKey] ? dayjs(filters?.[startKey]) : null,
            filters?.[endKey] ? dayjs(filters?.[endKey]) : null,
          ]}
          style={{ height: 40 }}
          disabledDate={disableFutureDates}
        />
      </div>
    );
  }
  if (type === "date_select") {
    return (
      <div>
        {showHeaders && <TitleText />}
        <Button onClick={handleFilter}>
          <SettingsOutline />
          Filter
        </Button>
      </div>
    );
  }

  if (type === "number" && rangeNames) {
    const minKey = rangeNames.startKey || `${name}_min`;
    const maxKey = rangeNames.endKey || `${name}_max`;

    return (
      <div style={{ display: "flex", gap: "4px" }}>
        <input
          type="number"
          className="form-control"
          name={minKey}
          defaultValue={filters?.[minKey] || ""}
          onBlur={(event) => {
            updateFilterValues({
              ...filters,
              [minKey]: event.target.value || null,
            });
          }}
          style={{ fontSize: 13, width: "50%" }}
          placeholder="Enter min amount"
        />
        <input
          type="number"
          className="form-control"
          name={maxKey}
          defaultValue={filters?.[maxKey] || ""}
          onBlur={(event) => {
            updateFilterValues({
              ...filters,
              [maxKey]: event.target.value || null,
            });
          }}
          style={{ fontSize: 13, width: "50%" }}
          placeholder="Enter max amount"
        />
      </div>
    );
  }

  return (
    <div>
      {showHeaders && <TitleText />}
      <input
        type="text"
        className="form-control"
        name={name}
        onBlur={(event) => onChange(name, event.target.value)}
        style={{ fontSize: 13 }}
        placeholder={showHeaders ? `Search ${header || name}` : ""}
      />
    </div>
  );
};
